import { Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, type UseModalState } from "@src/appV2/redesign/system/ui-components";

interface PastShiftOptionsBottomSheetProps {
  modalState: UseModalState;
  shiftId: string;
}

export function PastShiftOptionsBottomSheet(props: PastShiftOptionsBottomSheetProps) {
  const { modalState, shiftId } = props;

  const handleChatWithSupport = () => {
    logEvent(APP_V2_USER_EVENTS.PAST_SHIFT_DETAILS_CHAT_WITH_SUPPORT_TAPPED, { shiftId });
    void openZendeskMessaging();
    modalState.closeModal();
  };

  return (
    <BottomSheet
      footer={<DialogFooter orientation="vertical" />}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      modalState={modalState}
    >
      <Stack
        sx={{
          paddingTop: 4,
          paddingX: 4,
        }}
      >
        <Stack spacing={4}>
          <Button fullWidth variant="outlined" size="large" onClick={handleChatWithSupport}>
            Chat with support
          </Button>
        </Stack>
      </Stack>
    </BottomSheet>
  );
}
